module.exports = __webpack_public_path__ + "static/img/web4.0693c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/web/web4.png
// module id = E+HY
// module chunks = 0